"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ScheduleTimeZone.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Popover = require('web/components/Popover');
var _scheduledMessages = require('shared/services/scheduledMessages');
var _timeZones = require('shared/services/timeZones');







const Choice = _react.memo.call(void 0, ({ choice, selected, onPick }) => {
  const onClick = _react.useCallback.call(void 0, () => onPick(choice.id), [onPick, choice.id])
  return (
    _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}
      , _react2.default.createElement('button', { type: "button", className: "schedule-zone--choice", 'aria-pressed': selected, onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
        , choice.name
        , selected && _react2.default.createElement('i', { className: "material-icons schedule-zone--check" , 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}, "check")
      )
    )
  )
})
Choice.displayName = 'ScheduleTimeZoneChoice'









/* Under a send-time picker: "Time zone: Pacific Time (PT)", always a chosen
 * zone (the browser's unless the user changed it), and Change, which opens a
 * searchable list of zones (the US ones first). Escape or picking one closes
 * the list. */
const ScheduleTimeZone = ({ timeZone, onChange, at }) => {
  const [open, setOpen] = _react.useState.call(void 0, false)
  const [query, setQuery] = _react.useState.call(void 0, '')
  const searchId = _react.useId.call(void 0, )
  const line = _scheduledMessages.scheduleZoneLine.call(void 0, timeZone, at)
  // By its time: callers pass a new Date for the same instant.
  const atTime = _optionalChain([at, 'optionalAccess', _ => _.getTime, 'call', _2 => _2()])
  const choices = _react.useMemo.call(void 0, 
    () => (open ? _timeZones.timeZoneChoices.call(void 0, _timeZones.deviceTimeZone.call(void 0, ), atTime === undefined ? undefined : new Date(atTime)) : []),
    [open, atTime],
  )
  const shown = _react.useMemo.call(void 0, () => _timeZones.filterTimeZoneChoices.call(void 0, choices, query), [choices, query])

  _react.useLayoutEffect.call(void 0, () => {
    if (open) _optionalChain([document, 'access', _3 => _3.getElementById, 'call', _4 => _4(searchId), 'optionalAccess', _5 => _5.focus, 'call', _6 => _6()])
  }, [open, searchId])

  const show = _react.useCallback.call(void 0, () => {
    setQuery('')
    setOpen(true)
  }, [])
  const pick = _react.useCallback.call(void 0, (zone) => {
    onChange(zone)
    setOpen(false)
  }, [onChange])
  const onQueryChange = _react.useCallback.call(void 0, (event) => setQuery(event.target.value), [])
  // Escape closes the list only, not the panel or dialog it is in: a Modal
  // closes on Escape's keyup, which comes once the list is gone.
  const onKeyDown = _react.useCallback.call(void 0, (event) => {
    if (event.key !== 'Escape') return
    event.preventDefault()
    event.stopPropagation()
    _Popover.swallowNext.call(void 0, 'keyup', 'Escape')
    setOpen(false)
  }, [])
  const close = _react.useCallback.call(void 0, () => setOpen(false), [])

  return (
    _react2.default.createElement('div', { className: "schedule-zone", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
      , _react2.default.createElement('div', { className: "schedule-zone--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
        , _react2.default.createElement('span', { className: "schedule-zone--current", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
          , line.label, " " , _react2.default.createElement('span', { className: "schedule-zone--value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, line.value)
        )
        , !open && (
          _react2.default.createElement('button', { type: "button", className: "schedule-zone--change", onClick: show, 'aria-label': "Change time zone"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}, "Change"

          )
        )
      )
      , open && (
        _react2.default.createElement('div', { className: "schedule-zone--picker", role: "group", 'aria-label': "Time zone" , onKeyDown: onKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
          , _react2.default.createElement('div', { className: "schedule-zone--search-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
            , _react2.default.createElement('input', {
              id: searchId,
              type: "search",
              className: "blm-text-input schedule-zone--search" ,
              placeholder: "Search time zones"  ,
              'aria-label': "Search time zones"  ,
              autoComplete: "off",
              value: query,
              onChange: onQueryChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
            )
            , _react2.default.createElement('button', { type: "button", className: "schedule-zone--change", onClick: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, "Cancel")
          )
          , shown.length ? (
            _react2.default.createElement('ul', { className: "schedule-zone--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
              , shown.map(choice => (
                _react2.default.createElement(Choice, { key: choice.id, choice: choice, selected: choice.id === timeZone, onPick: pick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}} )
              ))
            )
          ) : (
            _react2.default.createElement('p', { className: "schedule-zone--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}, "No time zone matches."   )
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ScheduleTimeZone)
